export enum LabProvider {
  academo = 'academo',
  amrita = 'amrita',
  chemCollective = 'chemCollective',
  concord = 'concord',
  cosci = 'cosci',
  duffy = 'duffy',
  embed = 'embed',
  galileoAndEinstein = 'galileoAndEinstein',
  harshuEdu = 'harshuEdu',
  javaLab = 'javaLab',
  kcvs = 'kcvs',
  leoSiiman = 'leoSiiman',
  other = 'other',
  phet = 'phet',
  physicsaviary = 'physicsaviary',
  seilias = 'seilias',
  stAndrews = 'stAndrews',
  twente = 'twente',
  vascak = 'vascak',
  virtualBiologyHtml5Lab = 'virtualBiologyHtml5Lab',
  walterFendt = 'walterFendt',
  hbcse = 'hbcse',
  fatihTaser = 'fatihTaser',
  sadhanaPuntambekar = 'sadhanaPuntambekar',
  raimundGirwidz = 'raimundGirwidz',
  astroUnlEdu = 'astroUnlEdu',
  wulfranFortin = 'wulfranFortin',
}

export const stringToLabProvider = (provider: string): LabProvider | undefined => {
  if (provider in LabProvider) {
    return LabProvider[provider as keyof typeof LabProvider]
  }
  return undefined
}
